import { useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FacebookLogo, InstagramLogo, Link as LinkIcon } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../../components/auth/auth-heading';
import { OnboardingHeader } from '../../../../../components/auth/onboarding-header';
import { Button } from '../../../../../components/ui/button';
import { Input } from '../../../../../components/ui/input';
import { validateUrl } from '../../../../../lib/onboarding';
import { useOnboardingStore } from '../../../../../lib/onboarding-store';

export const Route = createFileRoute('/subdomain/app/_auth/onboarding/socials')({
  component: SocialsStep,
});

function SocialsStep() {
  const navigate = useNavigate();
  const { draft, updateDraft } = useOnboardingStore();
  const [touchedOther, setTouchedOther] = useState(false);

  const otherError = touchedOther ? validateUrl(draft.otherUrl) : undefined;

  return (
    <>
      <OnboardingHeader step={4} backTo="/subdomain/app/onboarding/website" />
      <AuthHeading
        title="Where can customers find you online?"
        subtitle="Add the pages you already have. You can skip any."
      />

      <Input
        label="Instagram"
        leadingIcon={InstagramLogo}
        placeholder="@yourbusiness"
        autoCapitalize="none"
        value={draft.instagramHandle}
        onChange={(e) => updateDraft({ instagramHandle: e.target.value })}
      />
      <Input
        label="Facebook page"
        leadingIcon={FacebookLogo}
        placeholder="facebook.com/yourbusiness"
        autoCapitalize="none"
        value={draft.facebookUrl}
        onChange={(e) => updateDraft({ facebookUrl: e.target.value })}
      />
      <Input
        label="Other (YouTube, Zomato, Justdial…)"
        leadingIcon={LinkIcon}
        placeholder="Add a link"
        inputMode="url"
        autoCapitalize="none"
        value={draft.otherUrl}
        error={otherError}
        onChange={(e) => updateDraft({ otherUrl: e.target.value })}
        onBlur={() => setTouchedOther(true)}
      />

      <Button
        fullWidth
        disabled={Boolean(validateUrl(draft.otherUrl))}
        onClick={() => navigate({ to: '/subdomain/app/onboarding/phone' })}
      >
        Continue
      </Button>
    </>
  );
}
